import { publicNumber, changeWechatApi } from '@/api/customer.js'
export default {
  // 公众号列表
  publicNumber(callback) {
    publicNumber().then(callback)
  },
  // 公众号切换
  changeWechatApi(id) {
    let search = {
      original_id: id,
      status: 0
    }
    changeWechatApi(search).then((res) => {
      if (res.data.code === 0) {
        _g.toastMsg('success', '切换成功')
      } else {
        _g.toastMsg('error', res.data.error)
      }
    })
  }
}
